import React from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Link,
  LINK_VARIANT_HIGHLIGHT,
  TruncateAndTooltip,
  SpacingVertical,
  SPACING_4,
  Flex,
  Text,
  TEXT_VARIANT_SMALL_LIGHT
} from 'mailup-web-components'
import CheckItem from 'Components/CheckItem/CheckItem'

const Description = ({ message }) => {
  const intl = useIntl()
  const history = useHistory()

  const goToCheckup = e => {
    e.preventDefault()
    e.stopPropagation()

    history.push(`/messages/email/${message.IdMessaggio}/checkup/summary`)
  }

  const getMsgDscr = () => {
    let ret = `${intl.formatMessage({ id: 'Load.MailupCommon.Id' })} ${
      message.IdMessaggio
    }`
    if (message.Note) {
      ret += ' - ' + message.Note
    }
    return ret
  }

  return (
    <Flex margin='0 0 0 32px' flexDirection='column'>
      <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
        <TruncateAndTooltip text={getMsgDscr()} />
      </Text>
      <SpacingVertical variant={SPACING_4} />
      <Link onClick={goToCheckup} variant={LINK_VARIANT_HIGHLIGHT}>
        {intl.formatMessage({ id: 'Load.EmailCheckUp.GoToCheckUp' })}
      </Link>
    </Flex>
  )
}
const BlockingCheck = ({ message }) => {
  const intl = useIntl()

  const props = () => ({
    icon: 'ban',
    badge: intl.formatMessage({
      id: 'Load.EmailCheckUp.Block'
    })
  })

  return (
    <CheckItem {...props()} title={message.Subject} isFromAbTest>
      <SpacingVertical variant={SPACING_4} />
      <Description message={message} />
    </CheckItem>
  )
}

BlockingCheck.propTypes = {
  message: PropTypes.object
}
Description.propTypes = {
  message: PropTypes.object
}

export default BlockingCheck
